import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Zap, ShieldAlert, CheckCircle2 } from "lucide-react";

const PROVEDORES = [
  ["", "Selecione o provedor"],
  ["mercadopago", "Mercado Pago"],
  ["efi", "Efí (Gerencianet)"],
  ["asaas", "Asaas"],
  ["pagseguro", "PagSeguro"],
  ["outro", "Outro banco / PSP"],
];

export default function AutoPaymentConfig({ form, setForm }) {
  const pa = form.pagamento_automatico || {};
  const set = (k) => (e) => setForm((f) => ({ ...f, pagamento_automatico: { ...pa, [k]: e.target.value } }));
  const configurado = pa.provedor && pa.client_id && pa.client_secret && pa.chave_pix;
  const modoServidor = form.pagamento?.modo || "manual";
  const modo = modoServidor;
  const pendente = (pa.ativo && configurado ? "automatico" : "manual") !== modoServidor;
  const removerCredenciais = () => setForm((f) => ({ ...f, pagamento_automatico: { ...pa, ativo: false, provedor: "", chave_pix: "", client_id: "", client_secret: "__remover__", webhook_secret: "__remover__" } }));

  return (
    <div data-testid="auto-payment-config" className="sm:col-span-2 bg-violet-50/60 rounded-xl border border-violet-100 p-4 space-y-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <Zap className="w-5 h-5 text-violet-700 mt-0.5 shrink-0" />
          <div>
            <Label className="text-base font-semibold text-slate-800">Pagamento automático (API do banco)</Label>
            <p className="text-sm text-slate-500">Com a chave ligada e as credenciais preenchidas, o Pix passa de <b>manual</b> (comprovante + confirmação) para <b>automático</b> (QR com valor e confirmação instantânea).</p>
          </div>
        </div>
        <Switch data-testid="config-pagamento-ativo" checked={!!pa.ativo} onCheckedChange={(v) => setForm((f) => ({ ...f, pagamento_automatico: { ...pa, ativo: v } }))} />
      </div>

      <div data-testid="auto-payment-status" className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold border ${modo === "automatico" ? "bg-emerald-50 text-emerald-800 border-emerald-200" : "bg-slate-100 text-slate-600 border-slate-200"}`}>
        {modo === "automatico" ? <CheckCircle2 className="w-3.5 h-3.5" /> : <ShieldAlert className="w-3.5 h-3.5" />}
        MODO ATUAL: {modo === "automatico" ? "AUTOMÁTICO" : "MANUAL"}{pendente ? " · salve para aplicar as alterações" : pa.ativo && !configurado ? " · preencha as credenciais para ativar" : ""}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div>
          <Label className="text-sm font-semibold text-slate-700">Provedor</Label>
          <select data-testid="config-pagamento-provedor" value={pa.provedor || ""} onChange={set("provedor")} className="mt-1.5 h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-base">
            {PROVEDORES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </div>
        <div>
          <Label className="text-sm font-semibold text-slate-700">Ambiente</Label>
          <select data-testid="config-pagamento-ambiente" value={pa.ambiente || "sandbox"} onChange={set("ambiente")} className="mt-1.5 h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-base">
            <option value="sandbox">Testes (sandbox)</option>
            <option value="producao">Produção</option>
          </select>
        </div>
        <F label="Client ID / Access Token" testid="config-pagamento-client_id" value={pa.client_id} onChange={set("client_id")} placeholder="Fornecido pelo provedor" />
        <F label="Client Secret" testid="config-pagamento-client_secret" value={pa.client_secret === "__remover__" ? "" : pa.client_secret} onChange={set("client_secret")} placeholder="Deixe em branco para manter o salvo" type="password" />
        <F label="Chave Pix recebedora" testid="config-pagamento-chave_pix" value={pa.chave_pix} onChange={set("chave_pix")} placeholder="Chave Pix cadastrada no provedor" />
        <F label="Webhook secret (opcional)" testid="config-pagamento-webhook_secret" value={pa.webhook_secret === "__remover__" ? "" : pa.webhook_secret} onChange={set("webhook_secret")} placeholder="Deixe em branco para manter o salvo" type="password" />
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-slate-400">Os segredos ficam guardados no servidor e nunca são exibidos por completo. A conexão real com o provedor é ativada pela equipe técnica após homologação.</p>
        {(pa.client_id || pa.client_secret) && pa.client_secret !== "__remover__" && (
          <button type="button" data-testid="config-pagamento-remover" onClick={removerCredenciais} className="text-xs font-semibold text-rose-600 hover:text-rose-700">Remover credenciais salvas</button>
        )}
        {pa.client_secret === "__remover__" && <span className="text-xs font-semibold text-amber-700">Credenciais serão removidas ao salvar.</span>}
      </div>
    </div>
  );
}

function F({ label, value, onChange, placeholder, testid, type = "text" }) {
  return (
    <div>
      <Label className="text-sm font-semibold text-slate-700">{label}</Label>
      <Input data-testid={testid} type={type} value={value || ""} onChange={onChange} placeholder={placeholder} className="mt-1.5 h-11 text-base rounded-xl bg-white" autoComplete="off" />
    </div>
  );
}
